import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, Teleport as _Teleport } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "modal__card" }
const _hoisted_3 = { class: "modal__content" }
const _hoisted_4 = { class: "modal__title" }
const _hoisted_5 = {
  key: 0,
  class: "modal__update-time"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "modal__update-time"
}
const _hoisted_8 = {
  key: 0,
  class: "modal__custom-templates"
}
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "modal__footer" }
const _hoisted_11 = { class: "modal__footer-logo" }
const _hoisted_12 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_translated_text_component = _resolveComponent("translated-text-component")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_ctx.mounted)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(), _createBlock(_Teleport, { to: "#overlay-main" }, [
          (_ctx.show)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.stopCloseHandler && _ctx.stopCloseHandler(...args)), ["stop"])),
                class: _normalizeClass([
          {
            'modal': true,
            'modal--show': _ctx.show,
          },
          _ctx.modalData.customClassName,
        ])
              }, [
                _createElementVNode("div", _hoisted_2, [
                  (_ctx.modalData.icon)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["modal__icon", _ctx.modalData.iconClassName])
                      }, [
                        _createElementVNode("div", {
                          class: "modal__icon-content",
                          style: _normalizeStyle(`mask: url(${_ctx.modalData.icon}) no-repeat center;mask-size: contain;`)
                        }, null, 4)
                      ], 2))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.modalData.title), 1),
                    (!!_ctx.modalLastUpdate)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createVNode(_component_translated_text_component, { translation: "modal_update_datetime" }),
                          _createTextVNode(" " + _toDisplayString(_ctx.modalLastUpdate), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          (!!_ctx.modalCreateTime)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                _createVNode(_component_translated_text_component, { translation: "modal_creation_time" }),
                                _createTextVNode(" " + _toDisplayString(_ctx.modalCreateTime), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                  ])
                ]),
                (!!_ctx.modalData.templateName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.activeTemplate), { "template-data": _ctx.modalData }, null, 8, ["template-data"]))
                    ]))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "",
                      innerHTML: _ctx.modalData.content
                    }, null, 8, _hoisted_9)),
                (_ctx.modalData.hideModalBtn !== true)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: _normalizeClass(["modal__buttons", _ctx.directionGoogleLink === 'user denied geolocation'
            ? '' : ''])
                    }, [
                      (_ctx.directionWazeLink !== '')
                        ? _withDirectives((_openBlock(), _createElementBlock("div", {
                            key: 0,
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigate('waze'))),
                            class: "modal__button"
                          }, _cache[4] || (_cache[4] = [
                            _createElementVNode("svg", {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "19.829",
                              height: "19.389",
                              viewBox: "0 0 19.829 19.389"
                            }, [
                              _createElementVNode("defs"),
                              _createElementVNode("path", {
                                class: "a",
                                d: "M-200.118,578.466l-17.937,8.231a.942.942,0,0,0-.542.984.94.94,0,0,0,\r\n                    .781.808l7.614,1.276.868,7.169a.95.95,0,0,0,.774.817.914.914,0,0,0,.165.015.949\r\n                    .949,0,0,0,.847-.526l8.673-17.5a.949.949,0,0,0-.169-1.08A.943.943,0,0,0-200.118,\r\n                    578.466Z",
                                transform: "translate(218.606 -578.378)"
                              })
                            ], -1),
                            _createTextVNode(" WAZE ")
                          ]))), [
                            [_directive_ripple]
                          ])
                        : _createCommentVNode("", true),
                      (_ctx.directionGoogleLink !== '')
                        ? _withDirectives((_openBlock(), _createElementBlock("div", {
                            key: 1,
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigate('google'))),
                            class: "modal__button"
                          }, _cache[5] || (_cache[5] = [
                            _createElementVNode("svg", {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "19.829",
                              height: "19.389",
                              viewBox: "0 0 19.829 19.389"
                            }, [
                              _createElementVNode("defs"),
                              _createElementVNode("path", {
                                class: "a",
                                d: "M-200.118,578.466l-17.937,8.231a.942.942,0,0,0-.542.984.94.94,0,0,0,\r\n                    .781.808l7.614,1.276.868,7.169a.95.95,0,0,0,.774.817.914.914,0,0,0,.165.015.949\r\n                    .949,0,0,0,.847-.526l8.673-17.5a.949.949,0,0,0-.169-1.08A.943.943,0,0,0-200.118,\r\n                    578.466Z",
                                transform: "translate(218.606 -578.378)"
                              })
                            ], -1),
                            _createTextVNode(" Google ")
                          ]))), [
                            [_directive_ripple]
                          ])
                        : _createCommentVNode("", true)
                    ], 2))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_btn, {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeOverlay())),
                  class: "modal__close",
                  icon: "mdi mdi-close",
                  variant: "text"
                }),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("img", {
                      class: "modal__footer-logo-image",
                      src: require('@/assets/img/its-chorzow-male-logo.png'),
                      alt: "Logo"
                    }, null, 8, _hoisted_12)
                  ])
                ])
              ], 2))
            : _createCommentVNode("", true)
        ]))
      ]))
    : _createCommentVNode("", true)
}